import request from '@/utils/request';

/*get the impressum*/
export function getCtype(id,langcode="de") {
	return request({
		url: '/contenttype/'+id+'/de',
		method: 'get',
	});
}